import React, { useState } from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
import Button from "../common/Button/Button";
import DoneIcon from "@mui/icons-material/Done";
import useMediaQuery from "@mui/material/useMediaQuery";

const billingDetails = [
  {
    gradient: "transparent",
    package: "Basic",
    package_val: "AED 110",
    p1: "9 Standard listings",
    p2: "1 Featured listing",
    p3: [
      "Leads to dashboard and inbox",
      "Impressions and analytics",
      "Dealer / Seller profile",
      "Upload photos",
    ],
  },
  {
    gradient: "linear-gradient(180deg, #BFBFBF 0%, #EBEBEB 100%)",
    package: "Silver",
    package_val: "AED 220",
    p1: "22 Standard listings",
    p2: "3 Featured listing",
    p3: [
      "Leads to dashboard and inbox",
      "Impressions and analytics",
      "Dealer / Seller profile",
      "Upload photos",
    ],
  },
  {
    gradient: "linear-gradient(180deg, #DBA514 0%, #FCC201 100%)",
    package: "Gold",
    package_val: "AED 450",
    p1: "63 Standard listings",
    p2: "7 Featured listing",
    p3: [
      "Leads to dashboard and inbox",
      "Impressions and analytics",
      "Dealer / Seller profile",
      "Upload photos",
    ],
  },
  {
    gradient: "linear-gradient(180deg, #1F1F1F 0%, #616161 100%)",
    package: "Platinum",
    package_val: "AED 650",
    p1: "90 Standard listings",
    p2: "10 Featured listing",
    p3: [
      "Leads to dashboard and inbox",
      "Impressions and analytics",
      "Dealer / Seller profile",
      "Upload photos",
      "Feed Integration",
      "Upload Videos",
    ],
  },
];

function Billing() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  const [activeButton, setActiveButton] = useState("yearly");

  const BillingCard = (details) => {
    return (
      <Box
        sx={{
          width: { xs: "250px", sm: "282px" },
          height: { xs: "fit-content", sm: "540px" },
          display: "flex",
          flexFlow: "column",
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          borderRadius: "4px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "16px",
            background: details.gradient,
            marginBottom: { xs: "16px", sm: "32px" },
          }}
        ></Box>
        <Box>
          <Box>
            <Typography
              sx={{
                marginBottom: "8px",
                fontSize: "22px",
                lineHeight: "26px",
                fontWeight: "600",
              }}
              variant="h3"
            >
              {details.package}
            </Typography>
            <Typography
              sx={{
                fontSize: "32px",
                lineHeight: "36px",
                fontWeight: "700",
                display: "flex",
                alignItems: "end",
              }}
              variant="h2"
            >
              {details.package_val}
              <Typography
                sx={{
                  color: "#616161",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "600",
                  marginLeft: "8px",
                }}
                variant="subtitle2"
              >
                / Month
              </Typography>
            </Typography>
          </Box>
          <Divider sx={{ color: "#D6D6D6", marginY: "16px" }} />
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                color: "text.primary",
                marginBottom: "16px",
              }}
              variant="subtitle2"
            >
              {
                <DoneIcon
                  sx={{
                    color: "text.primary",
                    width: "13px",
                    height: "13px",
                    fontWeight: "bold",
                    marginRight: "3px",
                  }}
                />
              }
              {details.p1}
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                color: "text.primary",
              }}
              variant="subtitle2"
            >
              {
                <DoneIcon
                  sx={{
                    color: "text.primary",
                    width: "13px",
                    height: "13px",
                    fontWeight: "bold",
                    marginRight: "3px",
                  }}
                />
              }
              {details.p2}
            </Typography>
          </Box>
          <Divider sx={{ color: "#D6D6D6", marginY: "16px" }} />
          <Box sx={{ display: "flex", flexFlow: "column", rowGap: "16px" }}>
            {!mobMatch &&
              details.p3.map((p) => {
                return (
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: "text.primary",
                    }}
                    variant="subtitle2"
                  >
                    {
                      <DoneIcon
                        sx={{
                          color: "text.primary",
                          width: "13px",
                          height: "13px",
                          fontWeight: "bold",
                          marginRight: "3px",
                        }}
                      />
                    }
                    {p}
                  </Typography>
                );
              })}
            {details.package === "Platinum" ? (
              <>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "text.primary",
                  }}
                  variant="subtitle2"
                >
                  {
                    <DoneIcon
                      sx={{
                        color: "text.primary",
                        width: "13px",
                        height: "13px",
                        fontWeight: "bold",
                        marginRight: "3px",
                      }}
                    />
                  }
                  Feed Integration
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "text.primary",
                  }}
                  variant="subtitle2"
                >
                  {
                    <DoneIcon
                      sx={{
                        color: "text.primary",
                        width: "13px",
                        height: "13px",
                        fontWeight: "bold",
                        marginRight: "3px",
                      }}
                    />
                  }
                  Upload Videos
                </Typography>
                {mobMatch && (
                  <Divider sx={{ color: "#D6D6D6", marginBottom: "16px" }} />
                )}
              </>
            ) : (
              ""
            )}
          </Box>
        </Box>

        <Button
          sx={{
            marginBottom: { xs: "16px", sm: "32px" },
            width: "218px",
            height: "36px",
            marginTop: { sm: "auto" },
          }}
          variant={"outlined"}
          size="small"
          outColor="#255CCE"
          hoverBg="#255CCE"
          hoverTxColor="#fff"
          fontWeight="600"
          txColor={"#255CCE"}
          typoSize={"14px"}
        >
          Get {details.package} Package
        </Button>
      </Box>
    );
  };

  return (
    <Container
      disableGutters={true}
      sx={{
        marginY: { xs: "16px", sm: "72px" },
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        backgroundColor: { xs: "#fff", sm: "" },
        padding: { xs: "24px 16px", sm: "0px" },
        boxShadow: {
          xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          sm: "none",
        },
        borderRadius: { xs: "8px", sm: "0px" },
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "22px", sm: "32px" },
          lineHeight: { xs: "26px", sm: "36px" },
          fontWeight: { xs: 600, sm: 700 },
        }}
        variant={mobMatch ? "h3" : "h2"}
      >
        Package price table
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          width: "343px",
          height: "48px",
          backgroundColor: "#EBEBEB",
          marginTop: { xs: "16px", sm: "56px" },
          borderRadius: "8px",
          marginBottom: "56px",
          padding: "3px",
        }}
      >
        <Button
          size="small"
          variant="standard"
          typoVariant="subtitle2"
          typoSize="14px"
          fontWeight="600"
          txColor="text.primary"
          sx={{
            boxShadow:
              activeButton === "yearly"
                ? "0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04)"
                : "",
            height: "100%",
            backgroundColor: activeButton === "yearly" ? "#fff !important" : "",
            borderRadius: "8px",
            width: "50%",
          }}
          onClick={() => {
            setActiveButton("yearly");
          }}
        >
          Yearly billing
        </Button>
        <Button
          size="small"
          variant="standard"
          typoVariant="subtitle2"
          typoSize="14px"
          fontWeight="600"
          txColor="text.primary"
          sx={{
            height: "100%",
            backgroundColor:
              activeButton === "monthly" ? "#fff !important" : "",
            borderRadius: "8px",
            width: "50%",
            boxShadow:
              activeButton === "monthly"
                ? "0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04)"
                : "",
          }}
          onClick={() => {
            setActiveButton("monthly");
          }}
        >
          Monthly billing
        </Button>
      </Box>
      <Container
        disableGutters={true}
        sx={{
          display: "flex",
          flexFlow: { xs: "column", sm: "row" },
          columnGap: { sm: "24px" },
          rowGap: { xs: "24px", sm: "0px" },
          alignItems: "center",
        }}
      >
        {billingDetails.map((details) => {
          return BillingCard(details);
        })}
      </Container>
    </Container>
  );
}

export default Billing;
